;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import styles from './UnavailableMessage.module.scss';

const UnavailableMessage = () => {
  return (
    <p className={styles.unavailable_message} data-sentry-component="UnavailableMessage" data-sentry-source-file="UnavailableMessage.tsx">
      We&rsquo;re sorry, but this video is not available.
    </p>
  )
}

export default UnavailableMessage;
